export default "__VITE_ASSET__C1bEM5rc__"